module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-13.3cb738a3.png";